import React from 'react';
import { Dialog } from 'primereact/dialog';
import { sanitize } from 'dompurify';

const NacAutomationPayload = ({ dialogData, setDialogData }) => {

    const parseJson = json => sanitize(JSON.stringify(JSON.parse(json), null, 2));

    return (
        <Dialog className="nac-automation-payload-dialog" visible={!!dialogData} onHide={() => setDialogData(null)}
        style={{width:"80%"}}>
            <h5>Alert Payload</h5>
            {
                !!dialogData &&
                <pre dangerouslySetInnerHTML={{
                    __html: parseJson(dialogData),
                }} />
            }
        </Dialog>
    );
}

export default NacAutomationPayload;